import { render } from "./image.vue?vue&type=template&id=3bee54bf&scoped=true&ts=true"
import script from "./image.vue?vue&type=script&lang=ts"
export * from "./image.vue?vue&type=script&lang=ts"

import "./image.vue?vue&type=style&index=0&id=3bee54bf&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bee54bf"]])

export default __exports__